import { darkPalette } from "../palette";

export const MuiTab = {
  MuiTabs: {},
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: "none",
        backgroundColor: darkPalette.background.default,
      },
    },
  },
};
